export default __webpack_public_path__ + "static/media/tutorial-3.13902211.svg";